export default __webpack_public_path__ + "static/media/Magical Strings 2018 (95 of 264).9f0c6438.jpg";